import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=5a16fe0e&scoped=true&"
import script from "./CountDown.vue?vue&type=script&lang=js&"
export * from "./CountDown.vue?vue&type=script&lang=js&"
import style0 from "./CountDown.vue?vue&type=style&index=0&id=5a16fe0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16fe0e",
  null
  
)

export default component.exports